<script setup lang="ts">
    interface Props {
        label?: string;
        clickable?: boolean;
    }
    defineProps<Props>();
</script>

<template>
    <div
        class="mb-4"
        :class="{ 'cursor-pointer': clickable }"
    >
        <p
            v-if="label"
            class="label-text text-sm text-gray-600"
            v-text="label"
        ></p>
        <p
            v-if="$slots.default"
            class="text-gray-900"
        >
            <slot></slot>
        </p>
    </div>
</template>
